import React from "react";
import "./creditdashboard.scss";
import { Accordion, Offcanvas } from "react-bootstrap";
import DataTable from "../../../components/landing/Creditdashboard/DataTable/DataTable";
import { DateRange } from "react-date-range";
import DashboardTopCards from "./DashboardTopCards";
import { times } from "../../../utils/Constants";
import useCreditDashboardData from "../../../hooks/Refund/useCreditDashboardData";
const Creditdashboard = () => {
  const {
    show3,
    handleClose3,
    handleShow3,
    startDate,
    endDate,
    activeKey,
    setActiveKey,
    state,
    setState,
    stats,
    selectedTime,
    showDateFilter,
    dateFilterLabel,
    formatDates,
    fetchStats,
    applyFilters,
    clearFilters,
    handleTimeSelect,
    removeDateFilter,
    tableKey,
    refreshTable,
  } = useCreditDashboardData();



  return (
    <>
      <section className="creditdashboard">
        <div className="custom-container">
          <div className="topheadings">
            <div className="leftheadings">
              <p className="toppara">CREDITS REFUND</p>
              <h4 className="dashboardhead">Dashboard</h4>
            </div>
            <div className="forflexbutton">
              {showDateFilter && (
                <span className="filterspan">
                  <span className="strongpara">Date Filter:</span>{" "}
                  <span className="innerspan">{dateFilterLabel}</span>{" "}
                  <button className="crossbtn" onClick={removeDateFilter}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M10.8511 13.5L7.87234 9.1898L5.10638 13.5H3L6.78723 7.59592L3.25532 2.5H5.40426L8.08511 6.38367L10.617 2.5H12.7021L10.1064 6.40612H8.10638L13 13.5H10.8511Z"
                        fill="#02171D"
                      />
                    </svg>
                  </button>
                </span>
              )}
              <button onClick={handleShow3} className="filterbtn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                >
                  <path
                    d="M6 7.83333V11.8333L7.33333 10.5"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M5.99996 11.8333L4.66663 10.5"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.6667 7.16666V10.5C14.6667 13.8333 13.3334 15.1667 10 15.1667H6.00004C2.66671 15.1667 1.33337 13.8333 1.33337 10.5V6.49999C1.33337 3.16666 2.66671 1.83333 6.00004 1.83333H9.33337"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.6667 7.16666H12C10 7.16666 9.33337 6.49999 9.33337 4.49999V1.83333L14.6667 7.16666Z"
                    stroke="black"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Filters
              </button>
            </div>
          </div>
          <div className="top-cards">
            <DashboardTopCards stats={stats} startDate={startDate} endDate={endDate} />
          </div>
          <h6 className="latesthead">Latest transactions</h6>

          <DataTable key={tableKey} startDate={startDate} endDate={endDate} />
        </div>
      </section>

      <Offcanvas
        show={show3}
        onHide={handleClose3}
        placement="end"
        className="leadersfilter"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Filters</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Accordion activeKey={activeKey} onSelect={(e) => setActiveKey(e)}>
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <div className="headmain">
                  <div
                    className="sqauremain"
                    style={{
                      borderColor: activeKey === "0" ? "#329879" : "#485A5F",
                    }}
                  >
                    {activeKey === "0" && <span className="innerspan"></span>}
                  </div>
                  <p className="mainpara">Filter by Date</p>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div>
                  <DateRange
                    editableDateInputs={true}
                    onChange={(item) => {
                      formatDates([item.selection]);
                    }}
                    moveRangeOnFirstSelection={false}
                    ranges={state}
                  />
                </div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1">
              <Accordion.Header className="lastchild">
                <div className="headmain">
                  <div
                    className="sqauremain"
                    style={{
                      borderColor: activeKey === "1" ? "#329879" : "#485A5F",
                    }}
                  >
                    {activeKey === "1" && <span className="innerspan"></span>}
                  </div>
                  <p className="mainpara">Filter by Time</p>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className="timemain">
                  {times.map((time) => (
                    <div
                      key={time}
                      className={`timeinner ${selectedTime === time ? "active" : ""
                        }`}
                      onClick={() => handleTimeSelect(time)}
                    >
                      <p className="timepara">{time}</p>
                      {selectedTime === time && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="17"
                          viewBox="0 0 16 17"
                          fill="none"
                        >
                          <path
                            d="M3 8.5L6.66235 12.5L14 4.5"
                            stroke="black"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      )}
                    </div>
                  ))}
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          <div className="bottombtns">
            <button className="whitebtn" onClick={clearFilters}>
              Clear all
            </button>
            <button className="greybtn" onClick={applyFilters}>
              Apply
            </button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Creditdashboard;